// extracted by mini-css-extract-plugin
module.exports = {"content":"Legal_content__CNcz4","next":"Legal_next__2r2tB","bounce":"Legal_bounce__22MBc"};